import React from 'react';
import { orderBy } from 'lodash';

export default function Leaderboard({
  players,
  scores,
  limit = null,
  highlightId = null,
  title = 'Reyting',
  afterQuestion = null, // e.g. 1 → "#1-savoldan keyin"
  variant = 'default', // 'default' | 'scoreboard'
}) {
  const ranked = orderBy(
    players.map((p) => ({
      ...p,
      score: scores[p.id] !== undefined ? scores[p.id] : 0,
    })),
    ['score', 'name'],
    ['desc', 'asc']
  );
  const list = limit ? ranked.slice(0, limit) : ranked;
  const isBoard = variant === 'scoreboard';

  return (
    <div
      className={`leaderboard card-panel ${isBoard ? 'scoreboard' : 'teams-list'}`}
    >
      <div className="lb-head">
        <h3>{title}</h3>
        {afterQuestion != null && Number(afterQuestion) > 0 ? (
          <p className="lb-meta">#{afterQuestion}-savoldan keyin</p>
        ) : null}
      </div>
      <ol>
        {list.map((p, i) => {
          const isMe = highlightId === p.id;
          const place = i < 3 ? `place-${i + 1}` : '';
          return (
            <li
              key={p.id}
              className={`${isMe ? 'me' : ''} ${!p.connected ? 'dim' : ''} ${place}`}
            >
              <span className="rank" aria-label={`${i + 1}-o‘rin`}>
                {i + 1}
              </span>
              <span className="lb-name">
                {p.name}
                {isMe ? <span className="you-tag"> siz</span> : null}
              </span>
              <span className="lb-score">
                {p.score}
                <span className="lb-score-unit"> ball</span>
              </span>
            </li>
          );
        })}
      </ol>
    </div>
  );
}
